export default __webpack_public_path__ + "static/media/send.6e7069a2.gif";